import { useUserStore } from '@/store/modules/user/store.js';
import { authService } from '@/plugins/vue-auth.ts';

export default [
    { path: '/templates/list', redirect: { name: 'templates.index' } },
    { path: '/templates/edit/:id', redirect: { name: 'templates.update' } },
    { path: '/templates/create/:type', redirect: { name: 'templates.store' } },
    {
        path: '/templates',
        name: 'templates.index',
        component: () =>
            import(/* webpackChunkName: "templates-list" */ '../views/Templates/List.vue'),
        meta: {
            accountSelect: {
                disabled: false,
            },
            header: {
                account: true,
                notification: true,
                search: true,
                settings: true,
            },
            saveInUrl: ['accountId'],
        },
    },
    {
        path: '/templates/new/:type',
        name: 'templates.store',
        component: () => {
            return import(/* webpackChunkName: "templates" */ '../views/Templates/Edit.vue');
        },
        meta: {
            header: {
                account: true,
                notification: true,
                search: true,
                settings: true,
            },
            saveInUrl: ['accountId', 'type'],
        },
        beforeEnter: async () => {
            if (!authService.ready()) {
                await authService.waitForUser();
            }

            if (!useUserStore().parentAuthUser.canEditEmailTemplate()) {
                return { name: 'unauthorized' };
            }

            return true;
        },
    },
    {
        path: '/templates/:id',
        name: 'templates.update',
        component: () => {
            return import(/* webpackChunkName: "templates" */ '../views/Templates/Edit.vue');
        },
        meta: {
            header: {
                account: true,
                notification: true,
                search: true,
                settings: true,
            },
        },
    },
];
